import React from 'react'
import Footer from '../components/footerComponent/footer'
import History from '../components/historyComponent/historyComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function HistoryPage() {
    return (
        <Layout>
            <Header/>
            <History/>
            <Footer/>
        </Layout>
    );
};